<template>
    <div class="uk-width-1-3@l uk-width-1-2@m uk-width-1-1@s uk-flex-first uk-padding-small uk-height-medium">
        <slot />
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "GraphContainer",
});
</script>
